export default "__VITE_ASSET__BOLakxgc__"